/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { OrderOwners } from "@/models/api/orders/OrderOwners";
import { editOrderOwners, getOrderOwners } from "@/requests/order/order";
import { OWNER_TYPES } from "@/static/ownerTypes";
import { SnackbarModel } from "@/models/components/popup/Snackbar";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";

export interface OrderOwnersStateInterface {
  orderId: null | string;
  orderOwners: null | OrderOwners;
}

export const OrderOwnersState: OrderOwnersStateInterface = {
  orderId: null,
  orderOwners: null,
};

const OrderOwnersModule = defineModule({
  state: OrderOwnersState as OrderOwnersStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setOrderId(state, param: string | null) {
      state.orderId = param;
    },
    setOrderOwners(state, param: OrderOwners | null) {
      if (param !== null) {
        for (const item of param) {
          const share = item.share as unknown;
          if (typeof share === "string") {
            item.share = parseFloat(share);
          }
        }
      }
      state.orderOwners = param;
    },
  },
  actions: {
    async openOrderOwners(context, orderId: string): Promise<void> {
      const { commit, rootDispatch } = _moduleActionContext(context);
      commit.setOrderOwners(null);
      commit.setOrderId(orderId);
      const orderOwners = await getOrderOwners(orderId);
      commit.setOrderOwners(orderOwners);
      await rootDispatch.cashiersAndTraders.downloadOfficeProfileCashiersAndTraders();
    },
    async saveOrderOwners(context): Promise<void> {
      const { rootDispatch, commit, state } = _moduleActionContext(context);
      let tradersShare = 0;
      let cashiersShare = 0;
      if (state.orderOwners != null) {
        for (const owner of state.orderOwners) {
          if (owner.share < 1) {
            const snackbar = new SnackbarModel(filterCapitalize(i18n.t("minimumShareIs1%").toString()));
            snackbar.color = "error";
            rootDispatch.popup.addSnackbar(snackbar);
            return;
          }
        }
        for (const owner of state.orderOwners.filter((v) => v.ownerType === OWNER_TYPES.Trader)) {
          tradersShare += owner.share;
        }
        for (const owner of state.orderOwners.filter((v) => v.ownerType === OWNER_TYPES.Cashier)) {
          cashiersShare += owner.share;
        }
      }
      if (tradersShare > 100 || cashiersShare > 100) {
        const snackbar = new SnackbarModel(filterCapitalize(i18n.t("over100percent").toString()));
        snackbar.color = "error";
        rootDispatch.popup.addSnackbar(snackbar);
      } else {
        await rootDispatch.failIfRequestsInProgress();
        await editOrderOwners(state.orderId as string, state.orderOwners as OrderOwners);
        commit.setOrderId(null);
        rootDispatch.popup.addSavedOkSnackbar();
        await rootDispatch.orders.getOrderItemsTable(true);
      }
    },
  },
});

export default OrderOwnersModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, OrderOwnersModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, OrderOwnersModule);
